import { CSS, styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { RadioGroup as BaseRadioGroup } from "radix-ui";
import { ForwardedRef, forwardRef, useContext } from "react";
import { FieldContext } from "./Field";

export const RadioGroup = styled(BaseRadioGroup.Root, {});

export type RadioGroupItemProps = BaseRadioGroup.RadioGroupItemProps & {
  css?: CSS;
};
export const RadioGroupItem = forwardRef(function RadioGroupItem(
  props: RadioGroupItemProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  const { inputProps } = useContext(FieldContext);
  return (
    <Item {...inputProps} {...props} ref={ref}>
      <Indicator />
    </Item>
  );
});

const Item = styled(BaseRadioGroup.Item, {
  display: "inline-flex",
  size: 20,
  minSize: 20,
  border: "2px solid",
  borderColor: colors.outline,
  justify: "center",
  items: "center",
  rounded: 9999,
  "&[data-state='checked']": {
    background: colors.navy,
    borderColor: colors.navy,
  },
  "&[data-disabled]": {
    background: colors.warmGrey,
    borderColor: colors.outline,
  },
});
const Indicator = styled(BaseRadioGroup.Indicator, {
  size: 8,
  rounded: 9999,
  background: colors.cream,
});
